const EXPORT_TYPE_OPTIONS = {
  OFFER: 'OFFER SHEET',
  AWARD: 'AWARD SHEET',
  NEGOTIATION: 'NEGOTIATION SHEET',
  MARKETPLACE_AUCTION: 'MARKETPLACE AUCTION SHEET',
  SALES_HISTORY: 'SALES HISTORY SHEET',
  AWARDING_OPPORTUNITIES: 'AWARDING OPPORTUNITIES SHEET',
};

export default EXPORT_TYPE_OPTIONS;
